import dayjs from 'app/libs/dayjs';
import { getMeetgoCenterAvailable } from 'app/api';
import { useState } from 'react';
import useDetailPage from 'app/hook/cars/useDetailPage';

export default function useCallInquiry() {
	const [message, setMessage] = useState('');
	const { regCall } = useDetailPage();

	const callInquiry = async ({ centerData, centerCode, vehicleId, openLayer }) => {
		regCall();
		if (!centerCode && !centerData) {
			alert('차량의 믿고지점코드가 없습니다. 관리자에게 문의해주세요.'); // 테스트환경에서는 센터코드가 없는 차량들이 너무많아 임시처리함.
			throw new Error('MeetGo center code was not given');
		}
		let data = centerData;

		if (!centerData) {
			data = await getMeetgoCenterAvailable(centerCode, vehicleId)
				.then((res) => res?.data)
				.catch((e) => console.error(e));
		}

		const { todayCenterCustomerSupport, nextCenterCustomerSupport, centerPhoneNumber, vehicleSafetyPhoneNumber } = data;

		if (todayCenterCustomerSupport?.active) {
			const [startHour, startMinute] = todayCenterCustomerSupport.businessStartTime?.split(':');
			const [endHour, endMinute] = todayCenterCustomerSupport.businessEndTime?.split(':');

			const convertStart = dayjs({ hour: startHour, minute: startMinute });
			const convertEnd = dayjs({ hour: endHour, minute: endMinute });

			const isCenterWorkingTime = dayjs().isSameOrAfter(convertStart) && dayjs().isSameOrBefore(convertEnd);

			if (isCenterWorkingTime) {
				window.location.href = `tel:${vehicleSafetyPhoneNumber ?? centerPhoneNumber}`;
				return;
			}
		}

		const [, nextMonth, nextDay] = nextCenterCustomerSupport?.businessDate?.split('-') ?? [undefined, undefined, undefined];
		setMessage(`${nextMonth}월 ${nextDay}일 ${nextCenterCustomerSupport?.businessStartTime} 이후에 문의 가능합니다.`);
		openLayer();
	};

	return {
		message,
		callInquiry,
	};
}
